import React from "react";

export default function App() {
  const width = window.innerWidth;
  const isDesktop = width >= 768;

  const links = [
    { name: "3-4-3", url: "https://343.thabo.xyz/" },
    { name: "xpost", url: "https://xpost.thabo.xyz/" },
    { name: "gnome", url: "https://gnome.thabo.xyz/" },
  ];

  return (
    <div style={styles.container}>
      {/* Header */}
      <h1 style={styles.header}>Thabo</h1>

      <div style={styles.centeredSection}>
        {/* Meaning of Thabo */}
        <p style={styles.meaning}>
          <span style={styles.highlight}>"Thabo"</span> is Sesotho for{" "}
          <span style={styles.emphasis}>happiness.</span>
        </p>

        {/* Links */}
        <div
          style={{
            ...styles.linksContainer,
            ...(isDesktop ? styles.linksRow : styles.linksColumn),
          }}
        >
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.link}
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>© 2025</footer>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
    height: "100vh",
    backgroundColor: "#f7f7f7",
  },
  header: {
    position: "absolute",
    top: "20px",
    left: "20px",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  centeredSection: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center", // Center vertically
    alignItems: "center", // Center horizontally
  },
  meaning: {
    fontSize: "20px",
    textAlign: "center",
    fontStyle: "italic",
    color: "#444",
    marginBottom: "20px",
  },
  highlight: {
    color: "#007BFF",
    fontWeight: "bold",
  },
  emphasis: {
    color: "#FF5722",
    fontWeight: "bold",
    fontSize: "22px",
    fontStyle: "italic",
  },
  linksContainer: {
    marginBottom: "20px",
  },
  linksRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  linksColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  link: {
    margin: "10px",
    fontSize: "18px",
    color: "#007BFF",
    textDecoration: "underline",
  },
  footer: {
    fontSize: "14px",
    color: "#999",
    marginBottom: "10px",
  },
};
